/* eslint-disable prettier/prettier */
import { get } from '@/infra/rest';
import { APIEndpoints } from '@/shared/constants/Endpoints';
import { QueryKeys } from '@/shared/constants/QueryKeys';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { AllVendorsListResponse, VendorDetails } from '../types';

export const getVendorsList = async (): Promise<AllVendorsListResponse> => {
  const response = await get<AllVendorsListResponse>({
    url: APIEndpoints.FetchVendorsList,
  });
  return response;
};

const getVendorRiskLevel = (risk: string) => {
  switch (risk) {
    case 'Low':
      return 1;
    case 'Medium':
      return 2;
    case 'High':
      return 3;
    default:
      return 4;
  }
};

const getVendorStatusLevel = (risk: string) => {
  switch (risk) {
    case 'pending_review':
      return 1;
    case 'in_review':
      return 2;
    case 'reviewed':
      return 3;
    default:
      return 4;
  }
};

export const useGetVendorsListQuery = () => {
  return useQuery<VendorDetails[]>({
    queryKey: [QueryKeys.AllVendorsList],
    queryFn: async () => {
      const response = await getVendorsList();
      return response.data
        .map((vendorDetails, vendorIndex) => ({
          ...vendorDetails,
          vendor_product_name: vendorDetails.vendor_name.concat(
            ' ',
            vendorDetails.product_name
          ),
          uid: `vendor-${vendorIndex}`,
          risk_level: getVendorRiskLevel(vendorDetails.risk),
          status_level: getVendorStatusLevel(vendorDetails.status),
        }))
        .sort((a, b) => {
          const aTime = dayjs(a.last_assessed).isValid()
            ? dayjs(a.last_assessed).valueOf()
            : 0;
          const bTime = dayjs(b.last_assessed).isValid()
            ? dayjs(b.last_assessed).valueOf()
            : 0;
          return bTime - aTime;
        });
    },
  });
};
